import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsServices(tenant: Tenant): Faq[] {
	return [
		{
			question: "Je možná spolupráce vašich IT specialistů s našim IT týmem?",
			answer:
				"Ano, pokud máte interní IT tým a potřebujete ho pouze doplnit/rozšířit, rádi se o to postaráme. Naši specialisté vám pomohou s realizací projektu a zároveň vám předají potřebné know-how.",
		},
		{
			question: "Máme IT problém a nevíme, jak ho řešit. Pomůžete nám s tím?",
			answer: "Ano, poskytneme vám IT konzultaci, na základě které navrhneme ideální řešení na míru.",
		},
		{
			question: "Jak dlouho trvá převzetí nedokončeného projektu?",
			answer:
				"Přibližně týden máme vyhrazený na nasdílení potřebných přístupů od klienta. Následně 1–2 týdny tvoříme přehled projektu a definujeme krátkodobé i dlouhodobé cíle.",
		},
		{
			question: "Jak velký IT tým nám můžete pronajmout?",
			answer:
				"Záleží na vašich potřebách. Můžeme vám pronajmout jednoho IT specialistu, ale pro větší projekty třeba i čtyři. Pokud nemáte představu, kolik ajťáků je na daný projekt potřeba, rádi vám poradíme.",
		},
	];
}
